import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AssessmentPreview from '../components/AssessmentPreview';
import WhatWeMeasure from '../components/WhatWeMeasure';
import RegisterBenefits from '../components/RegisterBenefits';
import CTASection from '../components/CTASection';
import TrustedBy from '../components/TrustedBy';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import ExitIntentPopup from '../components/ExitIntentPopup';

const QuickscanIntroPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AssessmentPreview />
        <WhatWeMeasure />
        <RegisterBenefits />
        <CTASection />
        <TrustedBy />
        <Stats />
        <Testimonials />
        <FAQSection />
      </main>
      <Footer />
      <ExitIntentPopup />
    </div>
  );
};

export default QuickscanIntroPage;
